import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';

import { cn } from '~/lib/utils';

interface SeparatorProps extends SeparatorPrimitive.Props {
  /**
   * Base UI's Separator always renders `role="separator"` (with no built-in
   * decorative opt-out prop), unlike the old Radix wrapper which defaulted to
   * decorative. All current app usages are purely visual rules, so default to
   * hiding them from assistive tech; pass `decorative={false}` to keep the
   * semantic separator role for a rule that carries real meaning.
   * @default true
   */
  decorative?: boolean;
}

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}: SeparatorProps) {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      orientation={orientation}
      {...(decorative ? { 'aria-hidden': true as const, role: 'none' } : {})}
      className={cn(
        'shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className
      )}
      {...props}
    />
  );
}

export { Separator };
